import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class EarthPressuresCalculationModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (EarthPressuresCalculationModel._instance == null) EarthPressuresCalculationModel._instance = new EarthPressuresCalculationModel(authManager);
        return EarthPressuresCalculationModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'earth-pressures/earth-pressures-calculations');

        this.entityName = 'earth-pressures.EarthPressuresCalculation';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Ps Calculation';
        this.setLabel = 'Ps Calculations';

        this.browser = {
            name: 'default-earth-pressures-earthpressurescalculation-browser',
            moduleName: 'default-earth-pressures-earthpressurescalculation-browser',
            moduleTitle: 'Ps Calculations',
            moduleStateSlotName: 'default-earth-pressures-earthpressurescalculation-browser',
        };

        this.editor = {
            name: 'default-earth-pressures-earthpressurescalculation-editor',
            moduleName: 'default-earth-pressures-earthpressurescalculation-editor',
            moduleTitle: 'Ps Calculation',
            moduleStateSlotName: 'default-earth-pressures-earthpressurescalculation-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
        ];

    }

}
